/**
 * Created by mukund on 6/10/15.
 */
'use strict';

angular.module('mediacloudApp')
    .controller('HeaderController', function ($rootScope, $scope, $location, $state, Auth, CollectionService, Principal, Tenant) {

        $(function() {
        Tenant.info().then(function (tenant) {
            $('.img-responsive').ready(function () {
            if (tenant.primaryColor) {
               $($('.img-responsive')[0]).attr('src', tenant.headerLogo);
               $($('.footer-logo')[0]).attr('src', tenant.footerLogo);
            }
            });
           });
        });

        $scope.$state = $state;
        $scope.isAuthenticated = Principal.isAuthenticated;

        // These variables are used for menu pagination
        $scope.menuItemsPerPage = 5;

        var resetMenuTrackers = function(){
            $scope.courseMenuTracker = { page: 0, total: 0 };
            $scope.channelMenuTracker = { page: 0, total: 0 };
            $scope.protectedCollectionMenuTracker = { page: 0, total: 0 };
        };

        resetMenuTrackers();

        // Load channels when the browser is refreshed - user need not be logged in
        CollectionService.GetAllCollections.get({type: 'CHANNEL', limit: $scope.menuItemsPerPage, offset: $scope.channelMenuTracker.page * $scope.menuItemsPerPage, paginated: true}, function(result){
            $scope.channels = result.collections;
            $scope.channelMenuTracker.total = result.totalCollections;
        });

        var loadCoursesAndCollections = function(){
            CollectionService.GetAllCollections.get({type: 'COURSE', limit: $scope.menuItemsPerPage, offset: $scope.courseMenuTracker.page * $scope.menuItemsPerPage, paginated: true}, function(result){
                $scope.courses = result.collections;
                $scope.courseMenuTracker.total = result.totalCollections;
            });
            CollectionService.GetAllCollections.get({type: 'PROTECTED', limit: $scope.menuItemsPerPage, offset: $scope.protectedCollectionMenuTracker.page * $scope.menuItemsPerPage, paginated: true}, function(result){
                $scope.protectedCollections = result.collections;
                $scope.protectedCollectionMenuTracker.total = result.totalCollections;
            });
        };

        // Load courses and collections when the browser is refreshed and the user is logged in
        if($scope.isAuthenticated()){
            Principal.identity().then(function(account) {
                $scope.account = account;
            });
            loadCoursesAndCollections();
        }

        // Load courses and collections when the user logs in
        $scope.$on('loggedIn', function(){
            Principal.identity().then(function(account) {
                $scope.account = account;
            });
            loadCoursesAndCollections();
        });

        $scope.$on('loggedOut', function(){
            resetMenuTrackers();
        });

        // Load additional courses or channels or collections upon user request.
        $scope.loadMore = function(type){
            if(type === 'CHANNEL'){
                $scope.channelMenuTracker.page++;
                CollectionService.GetAllCollections.get({type: 'CHANNEL', limit: $scope.menuItemsPerPage, offset: $scope.channelMenuTracker.page * $scope.menuItemsPerPage, paginated: true}, function(result){
                    $scope.channels = $scope.channels.concat(result.collections);
                    $scope.channelMenuTracker.total = result.totalCollections;
                    $('#channelMenu.dropdown').addClass('open');
                });
            } else if (type === 'PROTECTED'){
                $scope.protectedCollectionMenuTracker.page++;
                CollectionService.GetAllCollections.get({type: 'PROTECTED', limit: $scope.menuItemsPerPage, offset: $scope.protectedCollectionMenuTracker.page * $scope.menuItemsPerPage, paginated: true}, function(result){
                    $scope.protectedCollections = $scope.protectedCollections.concat(result.collections);
                    $scope.protectedCollectionMenuTracker.total = result.totalCollections;
                    $('#protectedCollectionMenu.dropdown').addClass('open');
                });
            } else if (type === 'COURSE'){
                $scope.courseMenuTracker.page++;
                CollectionService.GetAllCollections.get({type: 'COURSE', limit: $scope.menuItemsPerPage, offset: $scope.courseMenuTracker.page * $scope.menuItemsPerPage, paginated: true}, function(result){
                    $scope.courses = $scope.courses.concat(result.collections);
                    $scope.courseMenuTracker.total = result.totalCollections;
                    $('#courseMenu.dropdown').addClass('open');
                });
            }
        };

        $scope.logout = function () {
            Auth.logout();
            $rootScope.$broadcast('loggedOut');
            $state.go('home');
        };

    });
